import actionsTypes from '../../actionsTypes/home';

const INITIAL_STATE = {
  modal: {
    status: false,
    component: 0,
  },
  loading: false,
  userData: {
    email: '',
    cpf: '',
    password: '',
  },
  errorMessage: '',
};

function home(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionsTypes.HANDLEMODALHOME:
      return {
        ...state,
        modal: {
          status: action.status,
          component: action.component,
        },
      };
    case actionsTypes.HANDLELOADINGHOME:
      return {
        ...state,
        loading: action.status,
      };
    case actionsTypes.HANDLECHANGEHOME:
      return {
        ...state,
        userData: {
          ...state.userData,
          [action.name]: action.value,
        },
      };
    case actionsTypes.HANDLEERRORHOME:
      return {
        ...state,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}

export default home;
